import ScalarIconCaretUpDown_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCaretUpDown.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconCaretUpDown.vue
var ScalarIconCaretUpDown_default = ScalarIconCaretUpDown_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCaretUpDown_default as default };

//# sourceMappingURL=ScalarIconCaretUpDown.js.map